import React from "react";

export function UsCitizenIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 36.66"
      width="30"
      height="30"
      fill="white"
      {...props}
    >
      <rect className="cls-1" width="30.26" height="17.46" />
      <rect className="cls-1" x="32.58" y="7.1" width="31.42" height="3.49" />
      <rect className="cls-1" x="32.58" y=".58" width="31.42" height="3.49" />
      <rect className="cls-1" x="32.58" y="13.62" width="31.42" height="3.49" />
      <rect className="cls-1" y="20.13" width="64" height="3.49" />
      <rect className="cls-1" y="26.65" width="64" height="3.49" />
      <rect className="cls-1" y="33.17" width="64" height="3.49" />
    </svg>
  );
}
